const BULK_IMPORT_STATIC_ERRORS = {
  FILE_TYPE_MISMATCH: 'FILE_TYPE_MISMATCH',
  ORDER_COUNT_EXCEEDED: 'ORDER_COUNT_EXCEEDED',
  NO_ORDER_FOUND: 'NO_ORDER_FOUND',
  API_PROCESS_ORDER_FAILURE: 'process_order_failure',
  API_OVERLIMIT: 'overlimit',
  API_BAD_REQUEST: 'Request failed with status code 500',
  TEMPLATE_IS_OLD: 'TEMPLATE_IS_OLD',
}

export { BULK_IMPORT_STATIC_ERRORS }
